import { Badge } from '@mui/material';

export default Badge;
